export default "__VITE_ASSET__wY_hY5An__"